import { PaymentHistory, PaymentSignature } from "@edp-models/open-area.model";
import { Action } from "@ngrx/store";

export enum OpenAreaActions {
    GetOpenAreaCampaing = "[OpenArea] Get open area campaign",
    SetOpenAreaCampaign = "[OpenArea] Set open area campaign",
    GetSignatureValidation = "[OpenArea] Get signature validation",
    SetSignature = "[OpenArea] Set signature",
    GetCodeValidation = "[OpenArea] Get code validation",
    SetCodeValidation = "[OpenArea] Set code validation",
    GetBanks = "[OpenArea] Get banks",
    SetBanks = "[OpenArea] Set banks",
    GetNewCode = "[OpenArea] Get new code",
    SetNewCode = "[OpenArea] Set new code",
    GetPayment = "[OpenArea] Get payment",
    SetPayment = "[OpenArea] Set payment",
    SetPaymentStatus = "[OpenArea] Set payment status",
    GetPaymentStatus = "[OpenArea] Get payment status",
    SetPaymentHistory = "[OpenArea] Get payment history",
}

export class GetOpenAreaCampaing implements Action {
    public readonly type = OpenAreaActions.GetOpenAreaCampaing;
}

export class SetOpenAreaCampaign implements Action {
    public readonly type = OpenAreaActions.SetOpenAreaCampaign;
    constructor(public payload: any) {}
}

export class GetSignatureValidation implements Action {
    public readonly type = OpenAreaActions.GetSignatureValidation;
    constructor(public payload: PaymentSignature) {}
}

export class SetSignature implements Action {
    public readonly type = OpenAreaActions.SetSignature;
    constructor(public payload: any) {}
}

export class GetCodeValidation implements Action {
    public readonly type = OpenAreaActions.GetCodeValidation;
    constructor(public payload: any) {}
}

export class SetCodeValidation implements Action {
    public readonly type = OpenAreaActions.SetCodeValidation;
    constructor(public payload: any) {}
}

export class GetBanks implements Action {
    public readonly type = OpenAreaActions.GetBanks;
    constructor(public payload: any) {}
}

export class SetBanks implements Action {
    public readonly type = OpenAreaActions.SetBanks;
    constructor(public payload: any) {}
}

export class GetNewCode implements Action {
    public readonly type = OpenAreaActions.GetNewCode;
    constructor(public payload: any) {}
}

export class GetPayment implements Action {
    public readonly type = OpenAreaActions.GetPayment;
    constructor(public payload: any) {}
}

export class SetPayment implements Action {
    public readonly type = OpenAreaActions.SetPayment;
    constructor(public payload: any) {}
}

export class GetPaymentStatus implements Action {
    public readonly type = OpenAreaActions.GetPaymentStatus;
    constructor(public payload: any) {}
}

export class SetPaymentStatus implements Action {
    public readonly type = OpenAreaActions.SetPaymentStatus;
    constructor(public payload: any) {}
}

export class SetPaymentHistory implements Action {
    public readonly type = OpenAreaActions.SetPaymentHistory;
    constructor(public payload: PaymentHistory) {}
}

export class SetNewCode implements Action {
    public readonly type = OpenAreaActions.SetNewCode;
    constructor(public payload: any) {}
}


export type OAreaActions = GetOpenAreaCampaing
    | SetOpenAreaCampaign
    | GetSignatureValidation
    | SetSignature
    | GetCodeValidation
    | SetCodeValidation
    | GetBanks
    | SetBanks
    | GetNewCode
    | GetPayment
    | SetPayment
    | GetPaymentStatus
    | SetPaymentStatus
    | SetPaymentHistory
    | SetNewCode;
